import script from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocaleSelector.vue?vue&type=script&setup=true&lang=ts"

import "./LocaleSelector.vue?vue&type=style&index=0&id=40c2385b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c2385b"]])

export default __exports__